import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { colorsByPublicEditProfile } from '../../store/performers.era'
import { SubSession } from '../../store/share.brief.functions';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TrafficLightDropdownComponent } from '../misc/traffic-light-dropdown.component';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'add-link-to-brief-wrapper',
    templateUrl: './add-link-to-brief-wrapper.html',
    styleUrls: ['./add-link-to-brief-wrapper.scss'],
    standalone: true,
    imports: [MatSlideToggleModule, IconComponent, TrafficLightDropdownComponent, CommonModule],
})
export class AddLinkToBriefComponent {
  @Input() title
  @Input() highlighted = false
  @Input() dimmed = false
  @Input() fitContent = false
  @Input() toggleOn = true
  @Input() statusOn = false
  @Input() disabled = false
  @Input() configurable = false
  @Input() titleIcon: string // for assets
  @Input() sessions: SubSession[] // for presentation assets

  @Input() configureLabel = 'Configure'
  @Input() colors = colorsByPublicEditProfile
  @Input() toggleStates = ['OFF', 'ON']
  @Input() selected:string
  @Input() statusOptions: string[] = ['Active','Submitted']
  @Input() statusId:string
  @Output() toggle: EventEmitter<boolean> = new EventEmitter()
  @Output() toggleStatus: EventEmitter<any> = new EventEmitter()
  @Output() openConfigurations: EventEmitter<boolean> = new EventEmitter()

}




